const airport=value=>[
 ['NRT',/成田(?:空港|机场)|narita.*airport|\bnrt\b/i],
 ['HND',/羽田(?:空港|机场)|haneda.*airport|\bhnd\b/i],
 ['KIX',/関西(?:空港|国际机场)|关西机场|kansai.*airport|\bkix\b/i],
 ['ITM',/伊丹(?:空港|机场)|itami.*airport|\bitm\b/i],
].find(([,pattern])=>pattern.test(value||''))?.[0];
export function dailyRestRecords(legs){
 return legs.flatMap((leg,i)=>{
  let minutes=leg.stop_minutes||0;let source='parking';
  const start=leg.alighting_at||'';const next=legs[i+1];const code=airport(leg.dropoff);
  if(start&&next?.boarding_at&&code&&code===airport(next.pickup)){
   const gap=Math.floor((new Date(next.boarding_at)-new Date(start))/60000);
   if(gap>0){minutes=gap;source='airport_gap';}
  }
  if(minutes<30&&source!=='airport_gap')return [];
  return [{place:leg.dropoff||'—',start,minutes,source}];
 });
}
